import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { UtilsServiceProvider } from '@services/utils/utils-service';

@Injectable()
export class SubscriptionServiceProvider {
	constructor(private utilsService: UtilsServiceProvider) {}

	private subscriptionSource = new Subject<string>();
	subscription$ = this.subscriptionSource.asObservable();

	setSubscription(mission: string) {
		this.subscriptionSource.next(mission);
	}

	subscribeStripeModalWeb(plan: string, e: Event): void {
		this.setSubscription(plan);

		this.configureCardDetailsModal(plan);
		this.findModalToShowNext(e);
	}

	private configureCardDetailsModal(plan: string): void {
		const cardDetailsModal = document.getElementById('cardDetailsModal');

		if (cardDetailsModal) {
			const tmpClassList = cardDetailsModal.className
				.split(' ')
				.filter(item => {
					if (item.indexOf('show-banner-') !== 0) {
						return item;
					}
				});
			cardDetailsModal.className = tmpClassList.join(' ');

			cardDetailsModal.classList.add(`show-banner-${plan}`);
		}
	}

	private findModalToShowNext(e: Event): void {
		const subscriptionPageModal = document.getElementById(
			'subscriptionPageModal'
		);

		let _nexModalId;

		if (subscriptionPageModal) {
			const subscriptionModal = document.getElementById('subscriptionModal');

			if (subscriptionModal) {
				const subscriptionModalShowNow = subscriptionModal.classList.contains(
					'in'
				);
				_nexModalId = subscriptionModalShowNow
					? 'subscriptionModal'
					: 'cardDetailsModal';
				return this.showModal(_nexModalId, e);
			}
			$('#cardDetailsModal').modal('show');
		} else {
			const trialModal = document.getElementById('trialModal');

			if (trialModal) {
				const trialModalShowNow = trialModal.classList.contains('in');
				_nexModalId = trialModalShowNow ? 'trialModal' : 'subscriptionModal';
				this.showModal(_nexModalId, e);
			} else {
				this.showModal('subscriptionModal', e);
			}
		}
	}

	private showModal(modalId: string, e: Event): void {
		this.utilsService.showNextModal(`#${modalId}`, '#cardDetailsModal', e);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=nfw9yna8xro!./shared/services/subscription/subscription.service.ts